<template>
  <div>
        <div style="width: 100%; text-align: left; margin-top: -40px;">
            <h2>Edit Fabric Qty For {{rowData.tailoring_detail.template_name}}</h2>        
        </div>
        <br><br>
        
        <div 
            v-if="rowData.tailoring_detail.is_combination_item === 1" 
            style="display: flex; flex-direction: row;">

            <div 
                v-for="(data, index) in getCombinationItems"
                :key="index"
                :style="'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; margin-left: '+(index>0 ? '20px;' : '')+''">
                <span class="label">
                    {{data.tailoring_item_name}}
                </span>
                <el-input @focus="$event.target.select()"
                    :id="'fabric_field_'+index+'_'+(rowData.sl_no)"
                    @keyup.enter.native="closeWindow"
                    v-model="data.fabric_unit_qty"
                    type="number"
                    size="small"
                    style="width: 250px;">

                    <template slot="append">{{rowData.fabric_detail.unit_name}}</template>

                </el-input>
                
            </div>

            <el-button 
                @click="closeWindow"
                size="small" 
                type="primary" 
                style="width: 70px; height: 30px; margin-top: 20px; margin-left: 20px;">
                Ok
            </el-button>

        </div>
        <div v-else style="display: flex; flex-direction: row;">
            <div 
                :style="'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;'">
                <span class="label">
                    Fabric Qty
                </span>
                <el-input @focus="$event.target.select()"
                    :id="'fabric_field_0_'+(rowData.sl_no)"
                    @keyup.enter.native="closeNormal"
                    v-model="rowData.fabric_unit_qty"
                    type="number"
                    size="small"
                    style="width: 250px;">

                    <template slot="append">{{rowData.fabric_detail.unit_name}}</template>

                </el-input>
                
            </div>
            <el-button 
                @click="closeNormal"
                size="small" 
                type="primary" 
                style="width: 70px; height: 30px; margin-top: 20px; margin-left: 20px;">
                Ok
            </el-button>
        </div>
  </div>
</template>

<script>
export default {
    props: ['rowData'],
    computed: {
        getCombinationItems() {
            let list = this.rowData.combination_item_list

            list.forEach(element => {
                let tailoringItemIndex = this.rowData.tailoring_detail.combination_items.findIndex((t) => t.id === element.tailoring_item_id)
                if(tailoringItemIndex>=0) {
                    element.tailoring_item_name = this.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name
                }
            })

            return list
        }
    },
    methods: {
        closeNormal() {
            this.changeFocus('sale_net_total_'+this.rowData.key)
            this.$emit('closed')
        },
        closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce((count, element1) => {return count + parseFloat(element1.fabric_unit_qty);}, 0).toFixed(2);
            this.changeFocus('sale_net_total_'+this.rowData.key)
            this.$emit('closed')
        }
    },
    mounted() {
        setTimeout(() => {
            document.getElementById('fabric_field_0_'+(this.rowData.sl_no)).focus();
        }, 300);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/EditFabricQty.vue